import { useEffect, useState } from 'react';
import { api, type SupportPublicConfig } from './api';

// Config del canal de soporte (GOL-11). Se cachea en el módulo porque la lee cada
// apertura del panel de ayuda y cambia poquísimo: pedirla en cada apertura haría
// que la frase de expectativa apareciera un instante después del resto.
let cached: SupportPublicConfig | null = null;
let inFlight: Promise<SupportPublicConfig> | null = null;

export function supportConfigCached(): Promise<SupportPublicConfig> {
  if (cached) return Promise.resolve(cached);
  if (!inFlight) {
    inFlight = api.support.config()
      .then((cfg) => { cached = cfg; return cfg; })
      .finally(() => { inFlight = null; });
  }
  return inFlight;
}

export function useSupportConfig(): SupportPublicConfig | null {
  const [config, setConfig] = useState<SupportPublicConfig | null>(cached);

  useEffect(() => {
    let active = true;
    supportConfigCached()
      .then((cfg) => { if (active) setConfig(cfg); })
      .catch(() => { /* sin config el centro de ayuda sigue mostrando el FAQ */ });
    return () => { active = false; };
  }, []);

  return config;
}
